import { combineReducers } from 'redux';
import appVersionList from './appVersionList';
import fetching from './fetching';

export default combineReducers({
  appVersionList,
  fetching,
});
